<template>
  <div class="navbar">
    <div class="left-menu">
      <span
        class="cursor-pointer"
        @click="$router.push({ name: 'adManagement' })"
        >广告管理</span
      >
      <Account
        v-if="!hideNavbarAccount && !isAdmanagement && !isGoogleRoute"
        ref="selectAccount"
      />
      <AccountScore
        v-if="!hideNavbarAccount && !isAdmanagement && !isGoogleRoute"
        :account-id="currentAccountId"
      />
      <GoogleAccount
        v-if="isGoogleRoute"
        ref="selectGoogleAccount"
        @account-selected="handleAccountSelected"
      />
      <multi-account v-if="isAdmanagement"></multi-account>
      <!-- <auto-rules v-if="!hideNavbarAccount"></auto-rules> -->
    </div>
    <div class="right-menu">
      <el-button
        v-if="isAdManagement"
        type="primary"
        size="small"
        class="navbar-mcp-btn"
        @click="showMcpAccess = true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="navbar-mcp-btn-icon"
        >
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <path d="M9 9h6M9 12h6M9 15h4" />
        </svg>
        MCP 接入
      </el-button>
      <!-- 个号凭证：tooltip 只包原生节点，避免抢 cascader 点击 -->
      <el-tooltip
        v-if="selectNumObj"
        :content="numTooltipContent"
        :disabled="cascaderOpen || !numTooltipContent"
        effect="light"
        placement="bottom"
      >
        <span
          class="num-cascader-wrap"
          v-show="!hideNavbarAccount && numList.length && !isAdmanagement"
        >
          <el-cascader
            class="navbar-num-cascader"
            placeholder="请选择个号"
            :options="loginListLabel"
            :value="cascaderValue"
            filterable
            :filter-method="filterNumNode"
            :show-all-levels="false"
            ref="cascader"
            size="mini"
            separator=" / "
            popper-class="navbar-third-user-cascader"
            :props="cascaderProps"
            @visible-change="onCascaderVisible"
            @change="selectedThirdUser"
          >
            <template slot-scope="{ node, data }">
              <span
                v-if="node.isLeaf"
                class="num-cascader-leaf"
                :title="leafTooltip(data)"
              >
                <span
                  class="num-cascader-leaf__avatar"
                  :style="{ background: leafAvatarColor(data) }"
                  >{{ leafAvatarText(data) }}</span
                >
                <span class="num-cascader-leaf__body">
                  <span class="num-cascader-leaf__head">
                    <span class="num-cascader-leaf__name">{{ leafDisplayName(data) }}</span>
                    <span
                      v-if="leafAppName(data)"
                      class="num-cascader-leaf__tag"
                      >{{ leafAppName(data) }}</span
                    >
                  </span>
                  <span
                    v-if="leafShowEmail(data) || (data && data.id)"
                    class="num-cascader-leaf__meta"
                  >
                    <span
                      v-if="leafShowEmail(data)"
                      class="num-cascader-leaf__email"
                      >{{ leafShowEmail(data) }}</span
                    >
                    <span
                      v-if="data && data.id"
                      class="num-cascader-leaf__id"
                      >ID: {{ data.id }}</span
                    >
                    <i
                      v-if="data && data.id"
                      class="el-icon-document-copy num-cascader-leaf__copy"
                      title="复制凭证ID"
                      @click.stop="copyLeafId(data)"
                    ></i>
                  </span>
                </span>
              </span>
              <span
                v-else
                class="num-cascader-group"
                ><span class="num-cascader-group__name">{{ data.name }}</span
                ><i class="num-cascader-group__count">{{
                  (data.thirdLoginUsers || []).length
                }}</i></span
              >
            </template>
          </el-cascader>
        </span>
      </el-tooltip>
      <!-- 谷歌凭证 -->
      <GoogleCred
        v-if="isGoogleRoute"
        @credential-changed="handleCredentialChanged"
      />
      <!-- 快速切换账号 -->
      <change-account v-if="!hideNavbarAccount && numList.length"></change-account>
      <!-- 任务列表 -->
      <!-- <el-tooltip content="点击查看任务详情">
        <div
          class="task-wrap pr"
          @click="openTaskManage"
        >
          <i class="el-icon-document task-i pr"></i>
          <div class="pa num">{{ taskNum }}</div>
        </div>
      </el-tooltip> -->
      <!-- 配置/登录 -->
      <el-tooltip content="点击可配置个号信息和退出登录">
        <el-dropdown
          class="right-menu-container"
          trigger="click"
          @command="handleCommand"
        >
          <div class="right-menu-wrapper">
            <div class="avatar">
              <!-- 登录人头像：SSO 真实头像优先，缺失/加载失败退姓名 initials 色块，无登录态保持默认 -->
              <img
                v-if="loginUserAvatar && !avatarImgError"
                :src="loginUserAvatar"
                alt=""
                @error="avatarImgError = true"
              />
              <span
                v-else-if="loginUserName"
                class="avatar-initial"
                :style="{ background: hashColor(loginUserName) }"
                >{{ loginUserName.slice(0, 2).toUpperCase() }}</span
              >
              <img
                v-else
                src="@/assets/icon/default_avatar.jpg"
                alt=""
              />
            </div>
          </div>
          <!-- {{loginListLabel}} -->
          <el-dropdown-menu
            slot="dropdown"
            class="user-dropdown"
          >
            <!-- <router-link to="/userInfo">
              <el-dropdown-item command="config">配置</el-dropdown-item>
            </router-link>
            <router-link to="/likesSet">
              <el-dropdown-item command="config">偏好设置</el-dropdown-item>
            </router-link> -->
            <el-dropdown-item command="quit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>
    </div>
    <!-- 任务列表抽屉 -->
    <el-drawer
      title="任务列表"
      :visible.sync="taskManageVisible"
      direction="ltr"
      size="50%"
      :modal-append-to-body="true"
    >
      <task-manage @post-task-num="getTaskNum"></task-manage>
    </el-drawer>
    <el-dialog
      title="MCP 接入"
      :visible.sync="showMcpAccess"
      width="960px"
      append-to-body
      custom-class="mcp-access-dialog"
    >
      <mcp-access
        v-if="showMcpAccess"
        embedded
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { myLoginList, setDefault, loginListGroup } from '@/api/common/user';
import { sessionJobsCount } from '@/api/taskManage';
import Account from '@/layout/components/Navbar/Account.vue';
import AccountScore from '@/views/adManagement/components/AccountScore.vue';
import GoogleAccount from '@/layout/components/Navbar/googleAccount/index.vue';
import GoogleCred from '@/layout/components/Navbar/googleCred/index.vue';
import changeAccount from '@/layout/components/Navbar/changeAccount.vue';
import taskManage from '@/views/taskManage/index';
import autoRules from '@/layout/components/Navbar/autoRules';
import multiAccount from './Navbar/multiAccount.vue';
import McpAccess from '@/views/mcpAccess/index.vue';
import Cookies from 'js-cookie';
import { doSsoLogout } from '@/api/newLogin/index';
import clipboard from '@/utils/clipboard';
export default {
  components: {
    Account: Account,
    AccountScore,
    GoogleAccount,
    taskManage,
    autoRules,
    changeAccount,
    multiAccount,
    GoogleCred,
    McpAccess,
  },
  data() {
    return {
      taskNum: '',
      taskManageVisible: false,
      showMcpAccess: false,
      avatarImgError: false,
      loginListLabel: [],
      cascaderOpen: false,
      cascaderProps: { value: 'id', children: 'thirdLoginUsers', label: 'displayName' },
    };
  },
  computed: {
    ...mapState('num', ['selectedNum', 'numLists', 'selectNumLable']),
    ...mapState('user', ['userInfo']),
    ...mapGetters(['sidebar', 'hideNavbarAccount']),
    ...mapGetters('num', ['validNumLists', 'defNum']),
    currentAccountId() {
      return this.$store.getters.accountId || '';
    },
    isAdManagement() {
      return this.$route.name === 'adManagement';
    },
    numList() {
      let list = [...this.validNumLists];
      list.map((v) => {
        v.name = v.thirdUser.thirdUserName;
      });
      return list.sort(function (a, b) {
        return a.name.localeCompare(b.name, 'zh');
      });
    },
    selectNumObj() {
      return this.numLists.find((item) => item.id == this.selectedNum);
    },
    loginUser() {
      return (this.userInfo && this.userInfo.data) || null;
    },
    loginUserAvatar() {
      return (this.loginUser && this.loginUser.avatar) || '';
    },
    loginUserName() {
      return (this.loginUser && this.loginUser.name) || '';
    },
    numTooltipContent() {
      const thirdUser = this.selectNumObj && this.selectNumObj.thirdUser;
      if (!thirdUser) return '';
      const name = thirdUser.displayName || thirdUser.thirdUserName || '';
      const email = thirdUser.thirdUserEmail;
      return email ? `${name}（${email}）` : name;
    },
    cascaderValue() {
      return this.findNumPath(this.selectedNum);
    },
    isAdmanagement() {
      console.log(this.$route.path);
      return this.$route.path == '/ad/multiAccountManageIndex';
    },
    isGoogleRoute() {
      const routeName = this.$route.path;
      return routeName === '/google/adManagement' || routeName === '/google/create';
    },
  },
  watch: {},
  methods: {
    taskNumPoll() {
      setTimeout(() => {
        this.sessionJobsCount();
      }, 60000);
    },
    sessionJobsCount() {
      sessionJobsCount().then((res) => {
        if (res.code == 0) {
          this.taskNum = res.data ? res.data : 0;
          this.taskNumPoll();
        }
      });
    },
    leafRawName(data) {
      const thirdUser = (data && data.thirdUser) || {};
      // SYS_USER 凭证空名时后端 getter 会回退成“[凭证ID]”，不可作为展示名
      const dn = (thirdUser.displayName || '').trim();
      const usableName = dn && !/^\[\d+\]$/.test(dn) ? dn : '';
      return usableName || thirdUser.thirdUserName || (data && data.name) || '';
    },
    leafDisplayName(data) {
      const name = this.leafRawName(data);
      if (name) return name;
      // 名称缺失：依次回退邮箱、凭证 ID，避免空白卡片
      return this.leafDisplayEmail(data) || (data && data.id ? `ID: ${data.id}` : '未命名凭证');
    },
    leafDisplayEmail(data) {
      const thirdUser = data && data.thirdUser;
      return (thirdUser && thirdUser.thirdUserEmail) || (data && data.email) || '';
    },
    // 脱敏邮箱：仅当主行已有名称时展示，避免与主行回退内容重复
    leafShowEmail(data) {
      if (!this.leafRawName(data)) return '';
      return this.maskEmail(this.leafDisplayEmail(data));
    },
    maskEmail(email) {
      const at = (email || '').indexOf('@');
      if (at <= 0) return email || '';
      const local = email.slice(0, at);
      const domain = email.slice(at);
      if (local.length <= 2) return local[0] + '***' + domain;
      return local[0] + '***' + local[local.length - 1] + domain;
    },
    leafAvatarText(data) {
      return (this.leafDisplayName(data) || '?').slice(0, 2).toUpperCase();
    },
    // 头像色板：按文本哈希取固定色，同一名称颜色稳定
    hashColor(text) {
      const palette = ['#d64d8a', '#0e9f9f', '#5661d6', '#e0611c', '#207ae6', '#7a5af0', '#2ba471', '#c2453a'];
      const s = text || '';
      let hash = 0;
      for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
      return palette[hash % palette.length];
    },
    leafAvatarColor(data) {
      return this.hashColor(this.leafDisplayName(data));
    },
    leafAppName(data) {
      return (data && data.appInfo && data.appInfo.name) || '';
    },
    // 原生 title 兜底：hover 展示完整名称、邮箱与 ID，不干扰 cascader 点击
    leafTooltip(data) {
      const lines = [this.leafDisplayName(data)];
      const email = this.leafDisplayEmail(data);
      if (email) lines.push(email);
      if (data && data.id) lines.push(`ID: ${data.id}`);
      return lines.join('\n');
    },
    copyLeafId(data) {
      const id = data && data.id;
      if (id === undefined || id === null || id === '') return;
      clipboard(String(id))
        .then(() => this.$message.success('凭证ID已复制'))
        .catch(() => this.$message.error('复制失败，请手动复制'));
    },
    storedSelectNumLabel() {
      if (this.selectNumLable != null && this.selectNumLable !== '') return this.selectNumLable;
      const sessionVal = sessionStorage.getItem('selectNumLable');
      if (sessionVal) return sessionVal;
      return localStorage.getItem('selectNumLable');
    },
    findNumPath(selectedNum) {
      if (selectedNum === undefined || selectedNum === null || selectedNum === '') return [];
      const groups = this.loginListLabel || [];
      const stored = this.storedSelectNumLabel();
      if (stored != null && stored !== '') {
        const preferred = groups.find((group) => group.id == stored);
        const preferredUser = preferred && (preferred.thirdLoginUsers || []).find((user) => user.id == selectedNum);
        if (preferred && preferredUser) return [preferred.id, preferredUser.id];
      }
      for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        const user = (group.thirdLoginUsers || []).find((item) => item.id == selectedNum);
        if (user) return [group.id, user.id];
      }
      return [];
    },
    filterNumNode(node, keyword) {
      const query = (keyword || '').trim().toLowerCase();
      if (!query) return true;
      const data = (node && node.data) || {};
      const thirdUser = data.thirdUser || {};
      const appInfo = data.appInfo || {};
      const haystack = [data.name, data.displayName, data.email, data.id, thirdUser.displayName, thirdUser.thirdUserName, thirdUser.thirdUserEmail, appInfo.name]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return haystack.indexOf(query) !== -1;
    },
    onCascaderVisible(visible) {
      this.cascaderOpen = visible;
      if (visible && this.$refs.cascader) {
        this.$nextTick(() => {
          if (this.$refs.cascader) this.$refs.cascader.inputValue = '';
        });
      }
    },
    getTaskNum(num) {
      this.taskNum = num;
    },
    openTaskManage() {
      this.taskManageVisible = true;
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },

    clearAllCookies() {
      localStorage.removeItem('saToken');
      // 获取所有cookie名称
      const cookies = document.cookie.split(';');
      const cookieNames = cookies.map((cookie) => cookie.split('=')[0].trim()).filter((name) => name);

      // 所有可能的路径和域名组合
      const paths = ['/', '/ad', ''];
      const domains = [
        '',
        'addev.giikin.cn',
        '.addev.giikin.cn',
        'giikin.cn',
        '.giikin.cn',
        'giikin.com',
        '.giikin.com',
        window.location.hostname,
        '.' + window.location.hostname,
      ];

      // 暴力清除所有组合
      cookieNames.forEach((name) => {
        paths.forEach((path) => {
          domains.forEach((domain) => {
            const domainStr = domain ? `; domain=${domain}` : '';
            const pathStr = path ? `; path=${path}` : '';
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC${pathStr}${domainStr}; secure; samesite=none`;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC${pathStr}${domainStr}`;
          });
        });
      });

      // 最后再清理一遍当前可见的cookie
      document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        if (name) {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
        }
      });
    },
    handleCommand(c) {
      if (c == 'quit') {
        this.clearAllCookies();
        window.location.reload();
      }
    },
    myLoginList(platform) {
      this.$showLoading();
      let params = { platform };
      return myLoginList(params).then(async (res) => {
        this.$hideLoading();
        if (res.comment == 'ok') {
          // 个号列表存入-vuex
          await this.$store.dispatch('num/setNumLists', {
            numLists: res.data,
          });
        }
      });
    },
    loginListGroup() {
      let params = { platform: 'facebook' };
      return loginListGroup(params)
        .then((res) => {
          if (res.comment == 'ok' && Array.isArray(res.data)) {
            res.data.forEach((v) => {
              v.thirdLoginUsers = v.thirdLoginUsers || [];
              v.displayName = v.name;
              v.thirdLoginUsers.forEach((k) => {
                const thirdUser = k.thirdUser || {};
                k.name = thirdUser.thirdUserName;
                k.email = thirdUser.thirdUserEmail;
                // 回显 label 与面板名称共用同一回退链，杜绝输入框回显裸凭证 ID 或空值
                k.displayName = this.leafRawName(k) || thirdUser.thirdUserEmail || (k.id ? `ID: ${k.id}` : '');
              });
            });
            this.loginListLabel = res.data;
            const arr = this.f_handleDataTree(res.data, '');
            this.$store.commit('initData/setAllUseAdcounts', arr);
          }
        })
        .catch(() => {});
    },
    // 递归处理树
    f_handleDataTree(arr, val) {
      return arr.reduce((prev, cur, index, arr) => {
        if (cur.thirdLoginUsers) cur.thirdLoginUsers = this.f_handleDataTree(cur.thirdLoginUsers, cur.id);
        if (!val) {
          return [...prev, cur];
        } else return [...prev, { ...cur, pid: val }];
      }, []);
    },
    selectedThirdUser(val) {
      if (!Array.isArray(val) || val.length < 2 || val[1] == null || val[1] === '') return;
      this.$store.commit('num/selectNumLable', val[0]);
      this.changeNum(val[1]);
    },
    async changeNum(val, account_id) {
      await this.$store.dispatch('num/setSelectedNum', {
        selectedNum: val,
      });
      if (this.$refs['selectAccount']) {
        this.$refs['selectAccount'].isSearch = false;
        this.$refs['selectAccount'].$refs['cusHeader'].searchIpt = '';
      }

      localStorage.removeItem('activeAdAccount');
      this.$bus.$emit('trigger-getAdAccounts', account_id ? { obj: { id: account_id } } : {});
      // this.$showLoading();
      // setDefault({ id: val }).then(async res => {
      //   this.$hideLoading();
      //   if (res.comment == "ok") {
      //     await this.myLoginList("facebook");
      //     localStorage.removeItem("activeAdAccount");
      //     this.$bus.$emit("trigger-getAdAccounts", {});
      //   }
      // });
    },
    // 处理凭证切换事件
    handleCredentialChanged(data) {
      if (this.$refs.selectGoogleAccount) {
        this.$refs.selectGoogleAccount.handleCredentialChanged(data);
      }
    },
    // 处理账户选择事件
    handleAccountSelected(account) {
      console.log('账户已选择:', account);
      // 通过 Vuex 更新 Google 账户 ID
      this.$store.commit('initData/setAccountIdGoogle', account.accountId);
      this.$store.commit('google/setCreateAdAccount', account);
      // 通过事件总线通知 adManagement 组件更新 accountId
      this.$bus.$emit('google-account-selected', account.accountId);
    },
    // 处理Google路由缓存参数
    handleGoogleRouteParams() {
      // 只有在路由参数都没有的情况下才从缓存读取
      if (!this.$route.query.credentialUserId && !this.$route.query.account_id) {
        const credentialUserId = localStorage.getItem('googleCredentialUserId');
        const accountId = localStorage.getItem('googleAccountId');

        if (credentialUserId || accountId) {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              ...(credentialUserId && { credentialUserId }),
              ...(accountId && { account_id: accountId }),
            },
          });
        }
      }
    },
  },
  created() {
    this.$bus.$on('trigger-myLoginList', (platform) => {
      this.myLoginList(platform);
      this.loginListGroup();
    });
    this.loginListGroup();

    // 处理Google路由缓存参数
    if (this.isGoogleRoute) {
      this.handleGoogleRouteParams();
    }

    let account_id = this.$route.query.account_id;
    let third_user_id = this.$route.query.third_user_id;
    if (account_id && third_user_id) {
      this.changeNum(third_user_id, account_id);
    }
    // this.sessionJobsCount();
  },
};
</script>
<style>
.navbar-third-user-cascader.el-popper {
  /* 面板高度随视口自适应：小屏不溢出，大屏一次看到更多凭证 */
  --num-cascader-panel-h: min(calc(100vh - 96px), 860px);
  /* 面板定宽：element 菜单默认随内容撑宽，最长凭证名会把弹层拉到 700+px 且换行截断失效；定宽后右列名称按两行截断 */
  width: 640px;
  max-width: calc(100vw - 16px);
  margin-top: 6px;
  border: none;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 35, 70, 0.16);
  overflow: hidden;
}
.navbar-third-user-cascader .el-cascader-menu {
  /* 左列分组为固定轨道，剩余宽度全部让给右列凭证卡片 */
  flex: none;
  width: 168px;
  max-height: var(--num-cascader-panel-h);
  color: #303133;
  border-right: 1px solid #eef2f6;
}
.navbar-third-user-cascader .el-cascader-menu:last-child {
  flex: 1;
  min-width: 0;
  border-right: none;
  padding: 6px 8px;
}
.navbar-third-user-cascader .el-cascader-menu__wrap {
  height: var(--num-cascader-panel-h);
}
/* 右列凭证卡片：卡片化设计，对齐资产管理授权页风格 */
.navbar-third-user-cascader .el-cascader-menu:last-child .el-cascader-node {
  padding: 10px 12px;
  margin-bottom: 6px;
  border-radius: 8px;
  background: #f7f8fa;
}
.navbar-third-user-cascader .el-cascader-menu:last-child .el-cascader-node:not(.is-disabled):hover,
.navbar-third-user-cascader .el-cascader-menu:last-child .el-cascader-node:not(.is-disabled):focus {
  background: #eef2f7;
}
.navbar-third-user-cascader .el-cascader-menu:last-child .el-cascader-node.is-active {
  background: #ecf5ff;
  box-shadow: inset 2px 0 0 #207ae6;
}
/* 放开 element 对 label 的单行省略默认样式，否则卡片内容无法换行 */
.navbar-third-user-cascader .el-cascader-node__label {
  padding: 0;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
.navbar-third-user-cascader .el-cascader-node {
  height: auto;
  padding: 8px 14px;
  line-height: 1.4;
  align-items: flex-start;
}
.navbar-third-user-cascader .el-cascader-node:not(.is-disabled):hover,
.navbar-third-user-cascader .el-cascader-node:not(.is-disabled):focus {
  background: #f5f8fc;
}
.navbar-third-user-cascader .el-cascader-node.in-active-path,
.navbar-third-user-cascader .el-cascader-node.is-active {
  font-weight: 500;
  color: #207ae6;
  background: #f3f8ff;
}
.navbar-third-user-cascader .el-cascader-node.is-selectable.in-checked-path {
  color: #207ae6;
}
.navbar-third-user-cascader .el-icon-arrow-right {
  margin-top: 2px;
  color: #c0c4cc;
}
/* 左列分组卡片：与右列凭证同套卡片语言（圆角/灰底/hover/选中左蓝条），两列视觉合成一个面板 */
.navbar-third-user-cascader .el-cascader-menu:first-child {
  padding: 6px 8px;
}
.navbar-third-user-cascader .el-cascader-menu:first-child .el-cascader-node {
  padding: 10px 12px;
  margin-bottom: 6px;
  border-radius: 8px;
  background: #f7f8fa;
}
.navbar-third-user-cascader .el-cascader-menu:first-child .el-cascader-node:not(.is-disabled):hover,
.navbar-third-user-cascader .el-cascader-menu:first-child .el-cascader-node:not(.is-disabled):focus {
  background: #eef2f7;
}
.navbar-third-user-cascader .el-cascader-menu:first-child .el-cascader-node.in-active-path {
  background: #ecf5ff;
  box-shadow: inset 2px 0 0 #207ae6;
}
.navbar-third-user-cascader .el-cascader__suggestion-panel {
  min-width: 340px;
  max-height: var(--num-cascader-panel-h);
}
.navbar-third-user-cascader .el-cascader__suggestion-item {
  padding: 8px 14px;
  line-height: 1.4;
}
/* 搜索建议同为长名称入口：单行省略，完整名称靠 title 与选中后面板查看 */
.navbar-third-user-cascader .el-cascader__suggestion-item > span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navbar-third-user-cascader .el-cascader__suggestion-item:hover,
.navbar-third-user-cascader .el-cascader__suggestion-item.is-checked {
  color: #207ae6;
  background: #f3f8ff;
}
.navbar-third-user-cascader .el-scrollbar__wrap {
  overflow-x: hidden;
}
.navbar-third-user-cascader .num-cascader-group {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
  /* 右侧留出展开箭头（绝对定位 right:10px）的空间，避免计数徽标压箭头 */
  padding-right: 18px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.navbar-third-user-cascader .num-cascader-group__name {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navbar-third-user-cascader .num-cascader-group__count {
  padding: 0 6px;
  display: inline-block;
  font-style: normal;
  font-size: 11px;
  line-height: 16px;
  color: #909399;
  background: #f2f3f5;
  border-radius: 8px;
}
/* 选中分组：名称与计数徽标同步转蓝，与右列选中态呼应 */
.navbar-third-user-cascader .el-cascader-node.in-active-path .num-cascader-group {
  color: #207ae6;
}
.navbar-third-user-cascader .el-cascader-node.in-active-path .num-cascader-group__count {
  color: #207ae6;
  background: #d9ecff;
}
.navbar-third-user-cascader .num-cascader-leaf {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.navbar-third-user-cascader .num-cascader-leaf__avatar {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.navbar-third-user-cascader .num-cascader-leaf__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.navbar-third-user-cascader .num-cascader-leaf__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.navbar-third-user-cascader .num-cascader-leaf__name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  line-height: 1.45;
  /* 面板定宽后长名称在此换行，最多两行超出省略；完整名称见卡片 title 兜底 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: break-word;
}
.navbar-third-user-cascader .num-cascader-leaf__tag {
  flex: none;
  max-width: 120px;
  margin-top: 1px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #909399;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navbar-third-user-cascader .num-cascader-leaf__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: #909399;
}
.navbar-third-user-cascader .num-cascader-leaf__email {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.navbar-third-user-cascader .num-cascader-leaf__id {
  flex: none;
  color: #a8abb2;
}
.navbar-third-user-cascader .num-cascader-leaf__copy {
  flex: none;
  padding: 2px;
  font-size: 14px;
  color: #c0c4cc;
  cursor: pointer;
}
.navbar-third-user-cascader .num-cascader-leaf__copy:hover {
  color: #207ae6;
}
.third_user_cascader .el-cascader-menu {
  min-width: auto !important;
}
.mcp-access-dialog .el-dialog__body {
  padding: 8px 20px 20px;
  max-height: 76vh;
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  overflow: hidden;
  position: relative;
  color: #fff;
  background: #207ae6;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0 0 0 24px;
  .left-menu {
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 50px;
  }
    .right-menu {
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 50px;
    .navbar-mcp-btn {
      margin-right: 12px;
      background: linear-gradient(135deg, #4f6ef7, #8b5cf6) !important;
      border-color: transparent !important;
    }
    .navbar-mcp-btn-icon {
      margin-right: 4px;
      vertical-align: -2px;
    }
    .num-cascader-wrap {
      display: inline-flex;
      align-items: center;
      margin-right: 4px;
      line-height: 32px;
    }
    .navbar-num-cascader {
      width: 248px;
      line-height: 32px;
    }
    ::v-deep .navbar-num-cascader {
      .el-input__inner {
        height: 32px;
        line-height: 32px;
        padding: 0 28px 0 12px;
        color: #fff;
        background: #0c5dc2;
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 4px;
        box-shadow: none;
      }
      .el-input__inner::placeholder {
        color: rgba(255, 255, 255, 0.55);
      }
      .el-input .el-input__icon {
        line-height: 32px;
        color: rgba(255, 255, 255, 0.82);
      }
      .el-input.is-focus .el-input__inner,
      .el-input__inner:focus {
        border-color: rgba(255, 255, 255, 0.55);
      }
    }
    .right-menu-container {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      cursor: pointer;
      .right-menu-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 0 12px;
        .avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .avatar-initial {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            color: #fff;
            font-size: 12px;
            font-weight: 600;
          }
        }
      }
    }

    // task
    .task-wrap {
      margin-left: 12px;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .num {
        right: 0;
        top: -16px;
      }
      .task-i {
        color: #fff;
        font-size: 20px;
        top: 2px;
      }
    }
  }
}
</style>
